import React from 'react';
import {
   faFacebookF as faFacebook,
   faXTwitter as faXTwitter,
   faInstagram,
   faLinkedinIn as faLinkedin
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import VideoThumbnail from './VideoThumbnail';

const IconsList = [
   { icon: faFacebook, link: "https://facebook.com" },
   { icon: faXTwitter, link: "https://x.com" },
   { icon: faInstagram, link: "https://instagram.com" },
   { icon: faLinkedin, link: "https://linkedin.com" }
];

function SideCard({ course }) {

   const priceFormatted = course.price
      ? new Intl.NumberFormat('fr-FR', {
         style: 'currency',
         currency: course.currency || 'XOF',
      }).format(course.price)
      : 'Gratuit';

   const total_lessons =  (course.modules || []).reduce(
      (sum, m) => sum + ((m.lessons || []).length),
      0
   );

   const total_quizzes = 0; // A adapter selon la structure des données

   return (
      <div className="absolute top-0 right-0 z-50 transform translate-y-20 h-full">
         <div className="bg-white dark:bg-dark-5 rounded-2xl border border-gray-200
         dark:border-gray-700 overflow-hidden flex flex-col w-[400px] shadow-md backdrop-blur-md
         sticky top-32 h-[800px]">

            {/* Vidéo - Agrandie */}
            <div className="p-4 pb-0">
               <VideoThumbnail videoUrli={course.thumbnail || "https://docs.material-tailwind.com/demo.mp4"} />
            </div>

            {/* Contenu scrollable avec hauteur fixe */}
            <div className="overflow-y-auto flex-grow p-6" style={{ maxHeight: 'calc(80vh - 50px)' }}>
               {/* Prix */}
               <div className="flex justify-between items-center mb-6">
                  <div className="text-2xl font-semibold text-dark-1 dark:text-white">
                     {priceFormatted}
                  </div>
                  {/* <div className="line-through text-gray-500 dark:text-gray-400">$76.00</div> */}
               </div>

               {/* Boutons */}
               <div className="space-y-3 mb-6">
                  <button className="w-full bg-purple-1 text-white rounded-md transition-all duration-300
                     hover:text-purple-1 hover:bg-white border border-purple-1 py-3 font-medium">
                     Ajouter
                  </button>
                  <button className="w-full bg-white text-dark-1 rounded-md transition-all duration-300
                     hover:bg-dark-1 hover:text-white border border-dark-1 py-3 font-medium">
                     Acheter maintenant
                  </button>
               </div>

               <div className="text-sm text-center text-gray-600 dark:text-gray-400 mb-6">
                  Garantie de remboursement de 30 jours
               </div>

               {/* Détails */}
               <div className="space-y-4">
                  {[
                     { icon: "📹", label: "Lessons", value: `${total_lessons || 0}` },
                     { icon: "🧩", label: "Quizzes", value: `${total_quizzes}` },
                     { icon: "⏱️", label: "Duration", value: `${course.estimated_duration_hours || 0} h` },
                     { icon: "📊", label: "Skill level", value: `${course.difficulty_level || 'Débutant'}` },
                     { icon: "🌐", label: "Language", value: `${course.language || 'Français'}` },
                     { icon: "🏆", label: "Certificate", value: `${course.certificate ? 'Oui' : 'Non'}` },
                     { icon: "♾️", label: "Full lifetime access", value: `${course.lifetime_access ? 'Oui' : 'Non'}` },

                  ].map((item, index) => (
                     <div
                        key={index}
                        className={`flex justify-between py-3 ${index !== 0 ? "border-t border-gray-200 dark:border-dark-2" : ""
                           }`}
                     >
                        <div className="flex items-center text-dark-1 dark:text-white font-sans">
                           <span className="mr-3 text-lg">{item.icon}</span>
                           <span className="text-base">{item.label}</span>
                        </div>
                        <div className="text-gray-600 font-sans text-base">{item.value}</div>
                     </div>
                  ))}
               </div>
            </div>

            {/* Footer fixe */}
            <div className="px-6 py-4 border-t border-gray-200 dark:border-dark-2 bg-white dark:bg-dark-5">
               <div className="flex justify-center space-x-4">
                  {IconsList.map((social) => (
                     <a
                        key={social.link}
                        href={social.link}
                        className="flex justify-center items-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors duration-300"
                     >
                        <FontAwesomeIcon icon={social.icon} size="sm" className="text-gray-600 dark:text-gray-300" />
                     </a>
                  ))}
               </div>
            </div>
         </div>
      </div>
   );
}

export default SideCard;